import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit {
  @Input()
  showSpinner: boolean = false;

  constructor(private themService: ThemeService) { }

  ngOnInit(): void {
    this.themService.getShowSpinner().subscribe((res: boolean) => {
      this.showSpinner = res;
    })
  }
}
